import styled from "@emotion/styled";
import Calendar from "@engineering/icons/calendar";
import { bodyBold } from "@silvertours/front-shared";
var TopBarHeadline = /*#__PURE__*/ styled("div", {
    target: "e1kfjw1p0"
})(bodyBold);
var DatePickerButton = /*#__PURE__*/ styled("button", {
    target: "e1kfjw1p1"
})("display:inline-flex;flex-wrap:nowrap;align-items:center;gap:0.5rem;margin:0;padding:0.625rem 1rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.sm;
}, ";width:100%;height:3.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.default;
}, ";font-size:1rem;font-weight:600;line-height:1.5;text-transform:capitalize;text-align:left;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";cursor:pointer;&:hover,&:focus{border-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural30;
}, ";}");
var DatePickerValues = /*#__PURE__*/ styled("span", {
    target: "e1kfjw1p2"
})("display:inline-grid;grid-template-columns:1fr min-content 1fr;gap:0.5rem;align-items:center;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{gap:1rem;}");
var DatePickerValue = /*#__PURE__*/ styled("time", {
    target: "e1kfjw1p3"
})("width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;");
var DateSeparator = /*#__PURE__*/ styled("span", {
    target: "e1kfjw1p4"
})("width:1px;height:1.5rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural40;
}, ";");
var CalendarIcon = /*#__PURE__*/ styled(Calendar, {
    target: "e1kfjw1p5"
})("display:none;width:1.6rem;height:1.6rem;fill:currentcolor;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{display:block;}");
export { TopBarHeadline, DatePickerButton, DatePickerValues, DatePickerValue, DateSeparator, CalendarIcon };
